<style scoped="scoped" lang="scss">
	.container {
		padding-left: 24px;
		padding-right: 24px;
		overflow: auto;
		min-width: 500px;
	}
</style>
<template>
	<div class="container">
		<div>
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<!-- 缺陷类型 -->
				<el-tab-pane :label="$t('quexianleixing')" name="first">
					<div class="dialog-scroller" style="margin-left: -20px;">
						<defect_type ref="defect_type"></defect_type>
					</div>
				</el-tab-pane>
				<!-- 缺陷代码 -->
				<el-tab-pane :label="$t('quexiandaima')" name="second">
					<div class="dialog-scroller" style="margin-left: -20px;">
						<defect_code ref="defect_code"></defect_code>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script type="text/javascript">
	import defect_type from '@@/pages/web/base/defect/defect_type/list'
	import defect_code from '@@/pages/web/base/defect/defect_code/list'
	export default {
		name: 'web_base_defect_index',
		components: {
			defect_type,
			defect_code
		},
		data() {
			return {
				activeName: 'first',
			}
		},
		methods: {
			handleClick(tab, event) {
				this.$nextTick(() => {
					this.$refs.defect_type.yt.resetTableHeight()
				})
				this.$nextTick(() => {
					this.$refs.defect_code.yt.resetTableHeight()
				})
			},
		}
		
	}
</script>
